import React from 'react'
import {withStyles} from 'material-ui/styles'

import {redirect as text} from './text'
import styles from './styles'

import HeaderProgress from "../../common/components/HeaderProgress"
import qs from "query-string"
import { LoginAs } from "../../state/login/actions"

import {connect} from "react-redux"

class Redirection extends React.Component {
  componentDidMount() {
    const { lia } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true })

    if (lia) return this.props.loginAs(lia)

    return this.props.history.push('/micatalogo')
  }

  render() {
    const {classes} = this.props
    return (
      <React.Fragment>
        <HeaderProgress show={true} />
        <div className={classes.redirectContainer}>
          <p>{text.redirectText}</p>
        </div>
      </React.Fragment>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    loginAs: token => dispatch(LoginAs.loginAs(token)),
  }
}

const Container = connect(undefined, mapDispatchToProps)(Redirection)
const StyledRedirection = withStyles(styles, {withTheme: true})(Container)

export default StyledRedirection



// WEBPACK FOOTER //
// ./src/sections/redirection/redirection.js